export const EV_HEADER_LABELS = {
	SETTINGS_BUTTON_TITLE: 'Settings',
	LABEL_MANAGEMENT_OPTION_TITLE: 'Label Management',
	LOGO_ARIA_LABEL: 'Platform Home Page'
} as const;
